<template>
	<div class="order-body1">
		<div class="order-menu">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>售后单详情
		</div>
		<div class="valet-content-body">
			<div class="info-left">
				<div class="info-left-content">
					<valetCInfo @changeCus='changeCus' @setValue='getValue' @setSyscodeid='setSyscodeid' @setAddress='setAddress'
					:shopId='shopId' :afterSaleId='afterSaleId' :detailInfo='detailInfo' ref="topPart"/>
					<MainTable :acountValue='acountValue' :orderobj='orderobj' :afterSaleId='afterSaleId' :detailInfo='detailInfo' :bigClassList='bigClassList' :shopId='shopId' :organid='organid'
					:buyersyscodeid='buyersyscodeid' :address='address' :addressType='addressType' ref="midPart"/>
					<memoInfo :acountValue='acountValue' :orderobj='orderobj' :afterSaleId='afterSaleId' :detailInfo='detailInfo' ref="bottomPart"/>
				</div>
				<div class="valet-foot">
					<el-button class="btn" plain type="primary" size='small' @click="save(afterSaleId)" v-if="afterSaleId && AuthorityList['07_0005_0002_00']">确认修改</el-button>
					<el-button class="btn" plain type="primary" size='small' @click="save('')" v-if="!afterSaleId">提交</el-button>
				</div>
			</div>
			<div class="info-right">
				<DeliveryInfo :detailData="detailData" :afterSaleId='afterSaleId' :detailInfo='detailInfo' ref="deliveryInfo"/>
			</div>
		</div>
	</div>
</template>

<script>
import valetCInfo from '@/components/afterSaleOrder/valetCInfo.vue'
import MainTable from '@/components/afterSaleOrder/MainTable.vue'
import memoInfo from '@/components/afterSaleOrder/memoInfo.vue'
import DeliveryInfo from '@/components/afterSaleOrder/DeliveryInfo.vue'
export default {
	name: 'afterSaleOrder',
	components: {
		valetCInfo,
		MainTable,
		memoInfo,
		DeliveryInfo
	},
	data () {
		return {
			shopOptions: [],
			shopId: '',
			organid: '',
			active: '全部订单',
			dateValue: [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59'],
			buyerTel: '',
			orderNumber: '',
			paymentMode: '-1',
			acceptMode: '-1',
			cancelMode: '-1',
			pushstate: '-1',
			buyerName: '',
			acountValue: '',
			orderobj: {},
			bigClassList: [],
			detailData: [],
			buyersyscodeid: '',
			addressType: '',
			address: '',
			unpaidInvalidTime: 2,
			afterSaleId: '',
			detailInfo: {},
			AuthorityList: {
				'07_0005_0001_00': false,
				'07_0005_0002_00': false
			}
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '6-5')
		if (this.$route.query.id) {
			this.afterSaleId = this.$route.query.id
			this.getDetail()
		}
		this.getAuthority('07_0005_0000_00')
	},
	methods: {
		goBack () {
			this.$router.push('/main/afterSale')
		},
		changeCus (data) {
			this.$refs.bottomPart.isOffLine = data.isOffLine === 1
		},
		// 获取详情
		getDetail () {
			let data = {
				id: this.afterSaleId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/findAfterSaleOrderDetail`,
				data: data
			}).then(res => {
				if (res.result) {
					if (res.data.buyerAddress.indexOf('{"detail') > 0) {
						let acceptAddr1 = res.data.buyerAddress.slice(0, res.data.buyerAddress.indexOf('{"detail'))
						let acceptAddr2 = res.data.buyerAddress.slice(res.data.buyerAddress.indexOf('{"detail'))
						res.data.ob_address = acceptAddr1 + JSON.parse(acceptAddr2).detail + JSON.parse(acceptAddr2).local
					} else {
						res.data.ob_address = res.data.buyerAddress + res.data.buyerAddressDetail
					}
					this.detailInfo = res.data
					this.orderobj = res.data
					this.detailData = res.data.orderFollow
					this.acountValue = res.data.orderId
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		// 系统设置
		getSyestem () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/getOrderSystemSetting/`
			}).then(res => {
				if (res.result) {
					this.unpaidInvalidTime = res.data.unpaidInvalidTime
					console.log(this.unpaidInvalidTime)
				} else {
					this.$message.error(res.msg)
				}
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		},
		// 修改地址
		setAddress (type, value) {
			this.addressType = type
			this.address = value
		},
		// 获取大类
		getBigClss () {
			let data = {
				shopId: this.shopId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`,
				data: data
			}).then(res => {
				if (res.result) {
					let all = { bc_name: '全部', bc_id: '' }
					res.data.unshift(all)
					this.bigClassList = res.data
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		getValue (value, obj) {
			this.acountValue = value
			this.orderobj = obj
			this.$refs.midPart.tableData = []
			this.$refs.midPart.goodsMoney = '0.00'
			this.$refs.midPart.totalMoney = '0.00'
		},
		setSyscodeid (value) {
			this.buyersyscodeid = value
		},
		// 取消
		goOrder () {
			if (this.$refs.midPart.tableData.length !== 0) {
				this.$confirm('是否提交订单后，再关闭界面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.submit()
				}).catch(() => {
				})
			} else {
				let _path = `/main/order`
				this.$router.push(_path)
			}
		},
		showTip () {
			return new Promise((resolve, reject) => {
				this.$confirm('是否保存该客户地址？', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					resolve(true)
				}).catch(() => {
					resolve(false)
				})
			})
		},
		// 提交订单
		submit () {
			let valetCInfo = this.$refs.topPart
			let MainTable = this.$refs.midPart
			if (valetCInfo.value === '' || valetCInfo.value === null) {
				this.$message.error('请选择客户!')
				return false
			}
			if (MainTable.tableData.length === 0) {
				this.$message.error('请添加商品!')
				return false
			}
			let address = {}
			if (valetCInfo.radio === '0') {
				this.$refs.topPart.$refs['ruleForm'].validate((valid) => {
					if (!valid) {
						this.$message.error('请完善地址信息!')
						return false
					} else {
						this.showTip().then(res => {
							address = {
								area: JSON.parse(valetCInfo.ruleForm.province).areacode,
								district: valetCInfo.ruleForm.district,
								coordinate: valetCInfo.locationLng + ',' + valetCInfo.locationLat,
								province: JSON.parse(valetCInfo.ruleForm.province).id,
								city: JSON.parse(valetCInfo.ruleForm.city).id,
								name: valetCInfo.ruleForm.linkman,
								provincename: JSON.parse(valetCInfo.ruleForm.province).name,
								cityname: JSON.parse(valetCInfo.ruleForm.city).name,
								districtname: valetCInfo.ruleForm.districtname,
								addr: valetCInfo.ruleForm.address.replace(/[\r\n]/g, '') + valetCInfo.ruleForm.memo.replace(/[\r\n]/g, ''),
								street: valetCInfo.ruleForm.address.replace(/[\r\n]/g, ''),
								detailAddr: valetCInfo.ruleForm.memo.replace(/[\r\n]/g, ''),
								tel: valetCInfo.ruleForm.tel
							}
							this.save(address, res)
						})
					}
				})
			} else {
				for (let a = 0; a < valetCInfo.radioList.length; a++) {
					if (valetCInfo.radio === valetCInfo.radioList[a].id) {
						let addr = valetCInfo.radioList[a].addr
						let addr1 = ''
						let addr2 = ''
						if (addr.indexOf('{"detail":') !== -1) {
							addr1 = JSON.parse(addr).detail
							addr2 = JSON.parse(addr).local
						}
						address = {
							name: valetCInfo.radioList[a].name,
							provincename: valetCInfo.radioList[a].provincename,
							cityname: valetCInfo.radioList[a].cityname,
							districtname: valetCInfo.radioList[a].districtname,
							addr: valetCInfo.radioList[a].addrcopy,
							street: addr1,
							detailAddr: addr2,
							tel: valetCInfo.radioList[a].tel,
							addressid: valetCInfo.radioList[a].id
						}
						this.save(address, false)
					}
				}
			}
		},
		save (id) {
			let uploadInfo = []
			let valetCInfo = this.$refs.topPart
			let MainTable = this.$refs.midPart
			let memoInfo = this.$refs.bottomPart
			if (MainTable.tableData.length === 0) {
				this.$message.error('售后商品不可为空!')
				return false
			}
			for (let i = 0; i < 3; i++) {
				let img = {
					id: '',
					newurl: '',
					seqnum: i,
					oldurl: ''
				}
				if (memoInfo.showSrc[i] && memoInfo.showSrcCopy[i]) {
					if (memoInfo.showSrc[i].url === memoInfo.showSrcCopy[i].url) {
						img.id = memoInfo.showSrc[i].id
						img.newurl = memoInfo.showSrc[i].url
						img.oldurl = memoInfo.showSrc[i].url
					} else {
						img.id = memoInfo.showSrc[i].id
						img.newurl = memoInfo.showSrc[i].url
						img.oldurl = memoInfo.showSrcCopy[i].url
					}
				} else if (memoInfo.showSrc[i] && !memoInfo.showSrcCopy[i]) {
					img.newurl = memoInfo.showSrc[i].url
				} else if (!memoInfo.showSrc[i] && memoInfo.showSrcCopy[i]) {
					img.id = memoInfo.showSrcCopy[i].id
					img.oldurl = memoInfo.showSrcCopy[i].url
				}
				uploadInfo.push(img)
			}
			for (let i = 0; i < MainTable.tableData.length; i++) {
				let e = MainTable.tableData[i]
				if (e.afterSaleQuantity === '') {
					this.$message.error('［' + e.pName + '］售后数量不能为空！')
					return false
				}
				if (+e.afterSaleQuantity < 0 || +e.afterSaleQuantity > 9999.9999) {
					this.$message.error('［' + e.pName + '］售后数量范围为0-9999.9999！')
					return false
				}
				if (e.afterSaleMoney === '') {
					this.$message.error('［' + e.pName + '］售后金额不能为空！')
					return false
				}
				if (+e.afterSaleMoney < 0 || +e.afterSaleMoney > 9999.99) {
					this.$message.error('［' + e.pName + '］售后金额范围为0-9999.99！')
					return false
				}
				if (e.otherMoney === '') {
					this.$message.error('［' + e.pName + '］额外费用不能为空！')
					return false
				}
				if (+e.otherMoney < 0 || +e.otherMoney > 9999.99) {
					this.$message.error('［' + e.pName + '］额外费用范围为0-9999.99！')
					return false
				}
				if (e.afterSaleTypeValue === '') {
					this.$message.error('［' + e.pName + '］请选择售后分类！')
					return false
				}
				if (e.dealTypeValue === '') {
					this.$message.error('［' + e.pName + '］请选择处理方式！')
					return false
				}
				if (e.deptValue === '') {
					this.$message.error('［' + e.pName + '］请选择责任部门！')
					return false
				}
			}
			let data = {
				id: id,
				orderId: valetCInfo.orderid,
				memo: memoInfo.textarea,
				afterSaleDate: memoInfo.afterSaleDate,
				detail: MainTable.tableData,
				imgMap: uploadInfo
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/saveAfterSaleDetail`,
				data: data
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.$router.push('/main/afterSale')
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		findShopList () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
				}).then(res => {
					if (res.result) {
						resolve(res.data.shop)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body1 {
	flex: 1
	display flex
	flex-direction column
	overflow: hidden
	.shop-position {
		display flex
		align-items: center
		height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		line-height: 50px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
		span {
			display: inline-block;
			line-height: 50px;
			padding-right: 10px;
			margin-left: 20px;
			i {
				border-radius 50%
				text-align: center
				background: #9da6af
				padding: 3px
				cursor pointer
			}
			.el-icon-back {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
	}
	.valet-content-body {
		// height: 100%;
		flex: 1;
		min-height: 0;
		display flex;
		.info-left {
			flex: 1
			height: 100%
			overflow-y: auto;
			margin-right: 10px;
			display: flex;
			flex-direction: column
			.info-left-content {
				flex: 1;
				height: 100%
				overflow-y: auto;
			}
		}
		.info-right {
			display flex
			overflow-y :auto
			box-sizing: border-box
			width: 280px
		}
	}
	.valet-foot {
        height :40px;
        padding: 10px 0;
		text-align: left;
        .btn{
            width :130px;
			height :35px;
			margin: 0 30px
        }
	}
}
</style>
